import { BrazeAnalyticsDispatcher } from '../../AnalyticsContext/AnalyticsDispatchers/BrazeAnalyticsDispatcher';
import { ChildrenOnly } from '../../types/ChildrenOnly';
import { BrazeProvider } from './BrazeProvider';

export const BrazeWrapper = ({ children }: ChildrenOnly) => (
  <BrazeProvider>
    <BrazeAnalyticsDispatcher />
    {children}
  </BrazeProvider>
);
